import React from "react";
import styled from "styled-components";
import { Configuration } from "../../context/ConfigurationContext";
import useSlimInformation from "../../hooks/useSlimInformation";
import { PaletteConfiguration } from "../../util/ThemeUtil";
import { Wrapper } from "../Wrapper";
import SlimItem from "./SlimItem";

type ContainerStyleProps = {
  palette: PaletteConfiguration;
};

const SlimContainer = styled.div<ContainerStyleProps>`
  display: flex;
  flex-direction: column;
  background: ${(props) => props.palette?.background};
  width: 100%;
`;

type SlimViewProps = {
  config: Configuration;
  configMode?: boolean;
};

const SlimView: React.FC<SlimViewProps> = ({ config, configMode = false }) => {
  const { primary, primaryLabel, secondary, secondaryLabel } = useSlimInformation(config);
  const { palette } = config;
  return (
    <Wrapper backgroundColor={palette?.background} configMode={configMode}>
      <SlimContainer palette={palette}>
        <SlimItem palette={palette} label={primaryLabel} value={primary} />
        <SlimItem palette={palette} label={secondaryLabel} value={secondary} />
      </SlimContainer>
    </Wrapper>
  );
};

export default SlimView;
